import { CommonErrorType } from '../../common/enums';
import { SubscriptionPairingRequest } from '../../generated/api/subscriptionPairingRequest';
import { ValidateSubscriptionPairingResponse } from '../../generated/api/validateSubscriptionPairingResponse';
import { addEmptyFieldValidationError } from '../../common/utils/errorUtils';
import { fieldCantBeEmptyMsg, t } from '../../common/i18n';
import type { CommonError } from '../../common/types/errors';

export function getErrorsFromEmployeeSubscriptionPairingScene(
  data: SubscriptionPairingRequest,
  validationErrors?: CommonError[]
): CommonError[] | undefined {
  const errors: CommonError[] = [];
  if (data && data.msisdn === '') {
    addEmptyFieldValidationError(errors, 'msisdn', t.VPVR(fieldCantBeEmptyMsg));
  }
  if (data && data.subscriptionType === SubscriptionPairingRequest.SubscriptionTypeEnum.OTHER && !data.mdmId) {
    addEmptyFieldValidationError(errors, 'mdmId');
  }
  if (errors.length === 0) {
    return validationErrors;
  }
  return errors.concat(validationErrors || []);
}

export const getErrorsFromValidateEmployeeSubscriptionResponse = (
  response: ValidateSubscriptionPairingResponse
): CommonError[] | undefined => {
  const responseStatus = response && response.status;
  if (responseStatus === ValidateSubscriptionPairingResponse.StatusEnum.SUBSCRIPTION_NOT_FOUND) {
    return [
      {
        displayText: [
          t.S81T('Cannot pair subscription'),
          t.QNVB('This mobile number is not owned by a Elisa Corporate customer.'),
        ],
        message: t.W4RA('issue in subscription pairing'),
        type: CommonErrorType.NOT_FOUND,
      },
    ];
  } else if (responseStatus === ValidateSubscriptionPairingResponse.StatusEnum.BUSINESS_ID_MISMATCH) {
    return [
      {
        displayText: [
          t.S81T('Cannot pair subscription'),
          t.KG04('This mobile number is owned by another organisation.'),
        ],
        message: t.W4RA('issue in subscription pairing'),
        type: CommonErrorType.NOT_FOUND,
      },
    ];
  } else if (responseStatus === ValidateSubscriptionPairingResponse.StatusEnum.INVALID_OTP) {
    return [{ message: t.FI1N('Invalid verification code'), type: CommonErrorType.VALIDATION }];
  } else {
    return undefined;
  }
};
